export default __webpack_public_path__ + "static/media/corporate.0f086002.jpg";